import React from "react";
import { Element } from "react-scroll";
import { cardDetailsHomePage } from "../../data/data";
import { scrollToTop } from "../../utilities/utils";
import Button from "../button";

const UseHelpMatchHomePage = ({ title }) => {
  return (
    <Element name="why-helpMatch">
      <div className="bg-bodyColor">
        <div className="container mx-auto">
          <div className="flex flex-row justify-between max-xl:flex-col max-lg:text-center">
            <h2 className="font-bold lg:text-[48px] leading-[65px] text-[26px] max-lg:leading-[31px] text-customGray mr-[30px] w-[50%] max-xl:w-full max-xl:mb-[14px]">
              {title}
            </h2>
            <Button
              title="get matched now"
              classes="text-base leading-[160%] font-black text-bodyColor bg-primary rounded-[10px] py-3 md:py-6 md:px-10 uppercase w-full md:w-auto duration-500 hover:bg-[#026ed6] order-none md:order-2 capitalize md:block hidden"
              onClick={scrollToTop}
            />
          </div>
          <div className="grid grid-cols-4 max-xl:grid-cols-2 max-md:grid-cols-1 gap-[28px] max-lg:gap-5 mt-[60px] max-lg:mt-[15px]">
            {cardDetailsHomePage.map((card, index) => (
              <div
                key={`${index}-cardDetail`}
                style={{
                  backgroundColor: `${card.bgColor}`,
                  border: `1px solid ${card.borderColor}`,
                }}
                className="w-full py-[50px] px-5 lg:px-[30px] rounded-[30px] max-lg:min-h-[0px] cursor-pointer transform origin-center hover:scale-105 duration-500 ease-in-out text-center sm:text-left"
              >
                <div
                  style={{
                    backgroundColor: `${card.imgBgColor}`,
                    border: `1px solid ${card.imgBgColor}`,
                  }}
                  className="w-[72px] h-[72px] flex justify-center items-center rounded-[20px] mx-auto md:mx-0"
                >
                  <img
                    src={card.img}
                    alt={card.label}
                    className="mx-auto w-8 md:w-[40px]"
                  />
                </div>
                <h2 className="font-bold leading-[36px] text-customGray mt-[30px] mb-[10px] text-lg max-lg:leading-[29px] max-lg:mt-[20px] max-lg:mb-[10px]">
                  {card.title}
                </h2>
                <p className="font-[400] text-base leading-[29px] text-customGray max-lg:text-[18px] max-lg:leading-[29px]">
                  {card.detail}
                </p>
              </div>
            ))}
          </div>
          <button
            className="text-white lg:text-lg text-base font-black leading-[160%] h-full border-none bg-primary w-full p-3 rounded-[10px] mt-10 block md:hidden capitalize"
            onClick={scrollToTop}
          >
            get matched now
          </button>
        </div>
      </div>
    </Element>
  );
};

export default UseHelpMatchHomePage;
